import { EmptyState } from '@monorepo/shared/componentsV2/EmptyState';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { SitePickerForOrg } from '@monorepo/shared/componentsV2/SitePickerForOrg';
import { useOrgProjectsForUserWithPermission } from '@monorepo/shared/hooks/useOrgProjectsForUserWithPermission';
import React, { useEffect } from 'react';

export function WorkflowPreviewEmptyState({
  organizationId,
  onSelectSite,
  secondaryText,
}: {
  organizationId: string;
  onSelectSite: (projectId?: string) => void;
  secondaryText?: string;
}) {
  const { projects, isLoading } =
    useOrgProjectsForUserWithPermission(organizationId);

  useEffect(() => {
    if (projects?.length === 1) {
      onSelectSite(projects[0]?.id);
    }
  }, [projects, onSelectSite]);

  return (
    <EmptyState
      additionalContent={
        isLoading ? (
          <Loading />
        ) : (
          <SitePickerForOrg
            organizationId={organizationId}
            name="preview-site"
            isLabelHidden
            dontSaveSpaceForErrorText
            isErrorTextHidden
            onChange={(e) => onSelectSite(e.target.value as string)}
          />
        )
      }
      primaryText="Please select a preview site in order to view data"
      secondaryText={secondaryText}
    />
  );
}
